export { default } from './ControlPanel';
